export default __webpack_public_path__ + "static/media/pic14.53d37d10.jpg";